import { consolidateSpaces } from "./index93.js";
import { sortInsideOutsideSpaces } from "./index94.js";
import { getSpaceLimits } from "./index95.js";
import { getRequiredQuantity } from "./index96.js";
import { getSpacesByLevel } from "./index97.js";
import { TechSpaceErrorType } from "./index98.js";
import { errorHandler } from "./index101.js";
import { getModuleSizeZ } from "./index106.js";
import { insertModularSpaces } from "./index112.js";
import { getFreeAreasForSpaceInstances } from "./index113.js";
import { insertPodiumSpaces } from "./index121.js";
import { getApartmentArray } from "./index124.js";
import { RG_TYPE } from "@project-rouge/rg-core";
import { getRgObjectsOfType as getRgObjectsOfType$1 } from "@project-rouge/rg-three";
function addTechnicalSpaces({ building, buildingAttributes, requiredSpaces, forceInvalid, podiumProps, dataset }) {
	const invalid = [];
	const spacesAdded = [];
	const consolidated = [];
	let podiumMaxDepth = 0;
	if (podiumProps) {
		const moduleSizes = getRgObjectsOfType$1(building, RG_TYPE.Apartment).flatMap((a) => getRgObjectsOfType$1(a, RG_TYPE.Module).map((m) => getModuleSizeZ(m, a)));
		podiumMaxDepth = Math.min(...moduleSizes);
	}
	const { inside, leftover, outside } = sortInsideOutsideSpaces(requiredSpaces);
	const insideSpaces = [...inside, ...leftover];
	for (const space of outside) invalid.push({
		name: space.name,
		space,
		error: errorHandler(TechSpaceErrorType.NotImplementedProperty, {
			property: "attributes.requiredOutside",
			value: space.attributes.requiredOutside
		})
	});
	const bottomLevel = building.data.levels.find((lvl) => lvl.levelIndex === 0);
	const levels = building.data.levels.map((level) => level.levelIndex).sort((a, b) => a - b);
	levels.push(levels[levels.length - 1] + 1);
	const { spacesByLevel, leftover: unknownLocationSpaces } = getSpacesByLevel(levels, insideSpaces, 0);
	if (unknownLocationSpaces) for (const space of unknownLocationSpaces) invalid.push({
		name: space.name,
		space,
		error: errorHandler(TechSpaceErrorType.NoLevelInfo)
	});
	const roofFloor = Array.from(spacesByLevel.keys()).reduce((acc, key) => key > acc ? key : acc, Number.NEGATIVE_INFINITY);
	for (const space of spacesByLevel.get(roofFloor) || []) invalid.push({
		name: space.name,
		space,
		error: errorHandler(TechSpaceErrorType.NotImplementedProperty, {
			property: "attributes.levelLocation",
			value: "Roof"
		})
	});
	spacesByLevel.delete(roofFloor);
	const newChildren = [];
	const podiumLevels = [];
	if (podiumProps) podiumLevels.push(...building.data.levels.filter((l) => l.isPodium));
	for (const level of spacesByLevel.keys()) {
		const spacesRequiredOnLevel = /* @__PURE__ */ new Map();
		for (const space of spacesByLevel.get(level)) {
			const q = getRequiredQuantity(space, buildingAttributes);
			if (q === -1) invalid.push({
				name: space.name,
				space,
				error: errorHandler(TechSpaceErrorType.NoQuantityInfo)
			});
			else if (q === 0) invalid.push({
				name: space.name,
				space,
				error: errorHandler(TechSpaceErrorType.ZeroQuantityNeeded)
			});
			else spacesRequiredOnLevel.set(space, q);
		}
		const spacesList = consolidateSpaces(spacesRequiredOnLevel);
		const leanSpaces = [];
		for (const space of spacesList) {
			const sizeInfo = getSpaceLimits(space);
			leanSpaces.push({
				...sizeInfo,
				invalidatedSize: false,
				...space
			});
			if (space.includes && space.includes.length > 0) consolidated.push({
				name: space.space.name,
				space: space.space,
				includes: space.includes,
				spaceRequired: sizeInfo
			});
		}
		if (podiumLevels.map((level$1) => level$1.levelIndex).includes(level)) {
			newChildren.push(...building.children.filter((child) => child.data.level === level && child.type === RG_TYPE.Apartment));
			const { apartmentsAndTechSpaces, spacesAdded: spacesAddedAtLevel, invalidSpaces: errors } = insertPodiumSpaces(leanSpaces, building, getFreeAreasForSpaceInstances({
				building,
				targetLevel: podiumLevels.find((l) => l.levelIndex === level),
				levelHeight: podiumProps.height || buildingAttributes.PodiumHeight,
				depth: podiumMaxDepth
			}), {
				maxHeight: buildingAttributes.PodiumHeight,
				maxDepth: podiumMaxDepth
			}, forceInvalid, dataset);
			newChildren.push(...apartmentsAndTechSpaces);
			invalid.push(...errors);
			spacesAdded.push(...spacesAddedAtLevel);
		} else {
			const { sortedApartmentsAndTechSpaces, invalidSpaces: errors, spacesAdded: spacesAddedAtLevel } = insertModularSpaces(leanSpaces, getApartmentArray(building, level), forceInvalid, dataset, bottomLevel.uuid);
			invalid.push(...errors);
			spacesAdded.push(...spacesAddedAtLevel);
			for (const section of sortedApartmentsAndTechSpaces) if (section.length !== 0) newChildren.push(...section);
		}
	}
	const preservedChildren = building.children.filter((child) => child.type !== RG_TYPE.Apartment);
	building.children = newChildren.concat(preservedChildren);
	return {
		building,
		invalid,
		spacesAdded,
		consolidated
	};
}
export { addTechnicalSpaces };

//# sourceMappingURL=index125.js.map